import { jsx as o } from "react/jsx-runtime";
import { Fieldset as m } from "./fieldset.js";
import { Flex as s } from "./flex.js";
import { a, C as h } from "./chunks/checkbox.Crz_fNvI.js";
const e = (i) => {
  const { children: c, ...r } = i, { label: p, description: t, caption: n, error: d, invalid: l } = r;
  return /* @__PURE__ */ o(a, { ...r, children: /* @__PURE__ */ o(
    m,
    {
      invalid: l,
      label: p,
      description: t,
      caption: n,
      error: d,
      children: /* @__PURE__ */ o(s, { direction: "column", gap: 300, children: c })
    }
  ) });
};
e.displayName = "CheckboxGroup";
e.Checkbox = h;
export {
  e as CheckboxGroup
};
//# sourceMappingURL=checkbox-group.js.map
